import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Slider from "react-slick";
import config from "../../../config";
import { ImageList } from "../../../src/components/design-pages/imageList";

const tileData = [
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x450 SDH SAWAR FLORA HL, SDG SAWAR BROWN, SDG SAWAR BEIGE, SDM SAWAR BROWN FL.webp",
    alt: "Stylish grey bathroom design with countertop sink, window and beige Sawar tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x450 SDH TERRAZZO GREY HL, SDM TERRAZZO GREY DK, SDM TERRAZZO GREY LT, SDM TERRAZZO GREY FL.webp",
    alt: "Sophisticated grey bathroom design with a sleek sink, window, and shower area",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x450 SHG ECHO ONYX HL, SBG ONYX MULTI, SBG ONYX CREMA, SFM ONYX MULTI.webp",
    alt: "Modern grey bathroom design featuring a matte black bathtub and countertop sink",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x450 SHG FLOWER LEAF NERO HL, SBG SANDY NERO, SBG SANDY SILVER, SFM SANDY NERO.webp",
    alt: "Grey bathroom design with a mirror sink and a minimalist shower area",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x450 SHM TRIANGLE MULTI HL, SBM CEMENT GREY DK, SBM CEMENT GREY LT, SFM CEMENT GREY DK.webp",
    alt: "Elegant grey bathroom design featuring a sink, mirror, and cement grey tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x600 SDH ARGO GREY HL, SDM ARGO GREY DK, SDM ARGO GREY LT, SDF ARGO GREY FL.webp",
    alt: "Contemporary grey bathroom with a large window and white bathtub",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x600 SDH DUCATI GREY LEAVES HL, SDM DUCATI GREY DK, SDM DUCATI GREY LT, SDM DUCATI GREY FL.webp",
    alt: "Stylish grey bathroom design with a modern sink and white bathtub",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x600 SHG MARMI GEOMETRIC HL, SBG MARMI GREY DK , SBG MARMI GREY LT, SFM MARMI GREY DK.webp",
    alt: "Minimalist grey bathroom design with countertop sink and marble finish",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/300x600 SHM RUG MOSIAC HL, SBM RUG GREY DK, SBM RUG GREY LT, SFM RUG GREY DK.webp",
    alt: "Grey bathroom design with a modern countertop sink, mirror and western toilet",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/Carving Endless Rondline Grey & Carving Endless Rondline Grey DK_600x1200 mm.webp",
    alt: "Stylish grey bathroom featuring sink with cabinets and round mirror",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/LINE DECOR LEAF MULTI & DGVT Coquina Sand Grey LT_600x1200 mm.webp",
    alt: "Modern grey bathroom design featuring a sink with cabinets, round mirror and window",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/LINEA DECOR SANDY SMOKE MULTI, DGVT Sandy Smoke Silver & DGVT Sandy Smoke Charcoal_600x1200 mm.webp",
    alt: "Sleek grey bathroom design with sandy smoke tiles, white bathtub, sink and modern mirror",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/ODG Amelia Grey Dark, ODG Amelia Grey Light & ODH Amelia Decor HL_Bathroom_300x600 MM.webp",
    alt: "Chic grey bathroom design with matte black sink, mirror and window for added light",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/ODG Dorma Black, ODG Dorma Grey LT & ODH Dorma Chess HL_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
    alt: "Elegant grey bathroom with countertop sink, mirror and Dorma ceramic wall tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/ODG Lily Grey, ODH Lily Top HL & ODH Lily Bottom HL_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
    alt: "Sleek grey bathroom with a sophisticated sink and black matte Western toilet setup",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/ODM Jagna Grey Dark, ODM Jagna Grey Light & ODH Jagna HL_Bathroom Ambiance_Ceramic Wall Tiles_300x600 MM.webp",
    alt: "Grey bathroom with sink, cabinets and a window, offering a sleek design",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/SHG Brushed Elegant 3D Flowers HL, SBG Grey Brushed, SBG Slate Brushed & SFM Grey Brushed_300x450 mm.webp",
    alt: "Brushed grey tiles in a bathroom design with a sink, bathtub and small window",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/SHG DAISY EMPERADOR HL, SBG EMPERADOR BLACK MARBLE, SBG EMPERADOR BLACK MARBLE & SFM EMPERADOR BLACK MARBLE_300x450mm.webp",
    alt: "Stylish grey bathroom featuring a sink with cabinet, mirror, and black marble design",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/SHG Striato Exotic Leaf HL, SBG Grey Dusty, SBG Silver Dusty & SFM Grey Dusty_300x450 mm.webp",
    alt: "Modern grey bathroom design with a stylish sink, bathtub and large window",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/SHM Cemento Triangle Floral HL, SBM Taupe DK Cemento, SBM Taupe LT Cemento & SFM Taupe DK Cemento_300x450 mm.webp",
    alt: "Contemporary grey bathroom with bathtub, large window and Cemento Taupe tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/SHM Multi Frames Flowers HL, SBM Grey Frames, SBM White Frames & SFM Grey Frames_300x450 mm.webp",
    alt: "Grey bathroom design with a stylish sink, bathtub, and mirror in trendy frames",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/Modern grey bathroom design with accent tiles.webp",
    alt: "Modern grey bathroom design with floral accent tiles and a minimalist vanity",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/Grey bathroom design showcasing a patterned tile.webp",
    alt: "Grey bathroom design showcasing a glass shower panel",
  },
  {
    src: "https://images.orientbell.com/media/design-images/Grey - 21/Grey bathroom ideas pairs with white and a black tiles.webp",
    alt: "Sophisticated Grey bathroom ideas pairs with white and a black tiles shower fixture",
  },
];

const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
};
const faqs = [
  {
    question: "What aspects should I consider while planning a bathroom?",
    answer:
      "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also.",
  },
  {
    question: "Can a small bathroom be made to appear bigger?",
    answer:
      "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the décor minimal and using wall-mounted fixtures also helps to make the room feel more spacious.",
  },
  {
    question: "What are some of the recent trends in bathroom decor?",
    answer:
      "Popular trends in bathroom décor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic décor elements, have become popular choices, offering a mix of elegance and contemporary style.",
  },
  {
    question: "How to select the best flooring for my bathroom?",
    answer:
      "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget.",
  },
  {
    question: "Which type of lighting works the best in a bathroom?",
    answer:
      "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit. ",
  },
  {
    question:
      "Is it better to work with an expert designer or can I design my own bathroom?",
    answer:
      "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study.",
  },
];

const text = ` Grey is a colour that doesn't go out of style; it brings a modern touch and calmness to your bathroom. It's neutral in tone, making it easier to mix up different materials and features for a well-balanced look in the space. Grey bathroom designs are perfect for any bathroom remodelling project, be it a small or large space. It creates the desired impact without overwhelming the space, making it a smart choice for any design. 
Grey is known to create a soothing environment, which upgrades the overall comfort level and is easy on the eye. Mix light and dark shades of grey for depth, or use this colour for highlighting essential elements, grey does the job. With a grey bathroom interior design and selective materials of your choice, you can turn a bathroom into a comfortable, yet stylish place.`;

function GreyBathroom() {
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    getRelatedBlogs();
  }, []);

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=bathroom-designs`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
  return (
    <>
      <Head>
        <title>Grey Bathroom Ideas | Orientbell</title>
        <meta name="title" content="Grey Bathroom Ideas | Orientbell " />
        <meta
          name="description"
          content="Upgrade your space with grey bathroom design ideas from Orientbell. Get inspired and create a serene, stylish bathroom using our versatile grey tile designs"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.orientbell.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Design Ideas",
                  item: "https://www.orientbell.com/design-ideas/",
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "Bathroom Designs",
                  item: "https://www.orientbell.com/design-ideas/bathroom-designs",
                },
                {
                  "@type": "ListItem",
                  position: 4,
                  name: "Grey Bathroom",
                  item: "https://www.orientbell.com/design-ideas/bathroom-designs/grey-bathroom",
                },
              ],
            }),
          }}
        ></script>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              url: "/design-ideas/bathroom-designs/grey-bathroom",
              headline: "",
              breadcrumb:
                "Home > Design Ideas > Bathroom Designs > Grey Bathroom",
              name: "Grey Bathroom Ideas | Orientbell",
              description:
                "Upgrade your space with grey bathroom design ideas from Orientbell. Get inspired and create a serene, stylish bathroom using our versatile grey tile designs",
            }),
          }}
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "What aspects should I consider while planning a bathroom?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Can a small bathroom be made to appear bigger?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the décor minimal and using wall-mounted fixtures also helps to make the room feel more spacious.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What are some of the recent trends in bathroom decor?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Popular trends in bathroom décor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic décor elements, have become popular choices, offering a mix of elegance and contemporary style.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How to select the best flooring for my bathroom?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget.",
                  },
                },

                {
                  "@type": "Question",
                  name: "Which type of lighting works the best in a bathroom?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit.",
                  },
                },

                {
                  "@type": "Question",
                  name: "Is it better to work with an expert designer or can I design my own bathroom?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study.",
                  },
                },
              ],
            }),
          }}
        ></script>
      </Head>

      <div className="designpage-section">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/bathroom-designs">
              Bathroom Designs
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/bathroom-designs/grey-bathroom">
              Grey Bathroom
            </Breadcrumb.Item>
          </Breadcrumb>

          <div className="designpage-heading-bx padding-spacing">
            <h4>Showing {tileData.length} results for </h4>
            <h1>Grey Bathroom Design</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div className="obl-master-design-section">
            <h2>Grey Bathroom Design Gallery</h2>
            <div className="designpage-category-row inner-design-gallery">
              <ImageList tileData={tileData} />
            </div>

            <div className="bottom-content">
              <div className="common-text-content-section">
                <h2>Modern Grey Bathroom Ideas</h2>
                <p>
                  {`Grey bathrooms are loved because of their soothing and elegant
                  appeal. But how to make the most of it? Let's explore some
                  grey bathroom ideas to transform your space into a modern
                  comfortable one:`}
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Make it Look Spacious:</strong>
                    </h5>
                    <p>
                      Light grey tones make the bathroom look airy and spacious.
                      This particularly goes very well with grey{" "}
                      <a href="https://www.orientbell.com/design-ideas/bathroom-designs/small-bathroom">
                        {" "}
                        small bathroom designs{" "}
                      </a>
                      , creating an illusion of more space. This design can also
                      include a combination of mirrors and vertical storage to
                      maximise your bathroom space without sacrificing style.
                      Grey tones can soothe the eyes, giving one a relaxing
                      vibe. Softer lighting like wall sconces can enhance your
                      comfort level and make the space beautiful.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Mix Materials:</strong>
                    </h5>
                    <p>
                      Pair grey tiles with wood or stone elements for added
                      texture. Matte grey tiles along with wooden cabinets will
                      produce a very warm and welcoming look. You can also
                      choose between glossy-finish and textured grey tiles for
                      walls, while granite-look tiles could be used on the
                      countertop, with other decorative elements playing up
                      accordingly. These add elegance and elevate the impact of
                      the design. For instance, the grey subway tiles with black
                      colour countertops and white accents can give your
                      bathroom a rich look.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Minimalist Touch:</strong>
                    </h5>
                    <p>
                      Grey complements minimalist designs perfectly. Clean
                      lines, simple fixtures, and neutral shades can give any
                      bathroom with space limitations a sleek, modern vibe.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Accent Features: </strong>
                    </h5>
                    <p>
                      Add personality to your grey bathroom with bold accents.
                      Metallic finishes in gold or silver fixtures would add
                      great contrast. While a grey backsplash or mosaic floor
                      can add instant depth and texture to the space.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Modern Fixtures: </strong>
                    </h5>
                    <p>
                      Choose classy fixtures to complete your bathroom decor.
                      Frameless mirrors, metallic faucets, or a bathtub can
                      beautify and functionally fill your space. Use grey to
                      highlight the standout elements of your bathroom, perhaps
                      that statement bathtub or slick shower area. Grey matched
                      with metallic fixtures can easily elevate it to luxury.
                    </p>{" "}
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2> How Do I Determine My Modern Grey Bathroom Layout?</h2>
                <p>
                  Your bathroom layout design must be stylish as well as
                  practical. How do you go about designing one that suits your
                  needs and maximises the use of the bathroom space? These are
                  some tips on determining the most efficient bathroom layouts:
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Understand Your Space: </strong>
                    </h5>
                    <p>
                      How big or small your bathroom is, is important to plan
                      the layout. Start by measuring the entire area, and keep
                      in mind the placement of doors and windows. Also, keep a
                      note of any space limitations. This helps you determine
                      what can fit and where.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Prioritise safety:</strong>
                    </h5>

                    <p>
                      There should be enough space between fixtures, both for
                      comfort and safety. There should be ample room around the
                      toilet and other elements and the door must open without
                      obstruction. Proper spacing enhances airflow within the
                      bathroom and eases moving around.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Choose the Right Layout Style:</strong>
                    </h5>
                    <p>
                      A grey bathroom can work well with any type of layout
                      style, all of which offer their charm. Linear designs
                      focus on straight lines and symmetry for a clean look. For
                      an open feel, you can choose layouts that make the most of
                      space and create an easy flow.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Focus on Functionality:</strong>
                    </h5>
                    <p>
                      The key to designing a bathroom is taking into account
                      what you need and what matters most to you. Think about
                      how it will make your and your family’s day-to-day life
                      better. Do you want to install a bathtub, a shower, or
                      both? Adding a floating vanity or storage cabinet helps
                      keep the room organised. Design with functionality in
                      mind.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Optimise Movement:</strong>
                    </h5>
                    <p>
                      Ensure a smooth flow between fixtures for easy movement.
                      Avoid putting the toilet in a tight, awkward space, and
                      have enough room to easily move around from the vanity to
                      the shower and other features.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>
                  What Materials Should I Add to My Modern Grey Bathroom Design?
                </h2>
                <p>
                  {`The right selection of materials will enhance your grey
                  bathroom's look and functionality. Here are some options to
                  help you out:`}
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Tiles: </strong>
                    </h5>
                    <p>
                      Grey tiles are versatile, and one can find different
                      designs in this colour. The light grey wall tiles can be
                      matched with the dark grey floor tiles to achieve the
                      layered effect. Grey tiles with marble effects or
                      geometric patterns are sure to create a great style. You
                      should also consider creating a tile backsplash with
                      dolphin tiles and adding anti-skid floor tiles for the
                      final touch of safety.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Countertop: </strong>
                    </h5>
                    <p>
                      Granite-look tile countertops can give your bathroom a
                      luxurious feel. These materials are strong, non-porous,
                      and require minimal maintenance. Choose a countertop that
                      complements your grey backsplash or wall tiles for a
                      cohesive look.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Storage Cabinets:</strong>
                    </h5>
                    <p>
                      Storage cabinets could be one of the important elements in
                      your bathroom decor. You can try wooden cabinets to add
                      warmth, or open cabinets or wall shelves to give a
                      spacious feel. While the closed ones could be a good
                      option for keeping toiletries out of sight.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Faucets and Hardware: </strong>
                    </h5>
                    <p>
                      You will be able to find matching faucets and hardware in
                      a gold, matte black, or chrome finish. These finishes
                      would complement the grey tones of your bathroom perfectly
                      and give your bathroom a modern and shiny look. Also,
                      getting the right sink and shower head can enhance both
                      the functionality and style of your bathroom.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>How do I Decorate My Modern Grey Bathroom?</h2>
                <p>
                  Decorating a modern grey bathroom is all about blending your
                  needs while being stylish. Let’s check a few of the ideas to
                  decorate your space:
                </p>
                <ul>
                  <li>
                    {" "}
                    <h5>
                      <strong> Colour Scheme: </strong>
                    </h5>
                    <p>
                      Every bathroom can use the grey colour all across but with
                      some pops of colour. From dramatic black and blue to soft
                      colours like pink and yellow, various colours can
                      complement a grey bathroom. Go for the colour scheme that
                      matches your personality.
                    </p>
                  </li>

                  <li>
                    {" "}
                    <h5>
                      <strong>Play with Patterns and Tile Ideas:</strong>
                    </h5>
                    <p>
                      Play around with various wall tile patterns to bring life
                      to your grey bathroom. Patterns like geometric, floral, or
                      mosaic can add visual interest and texture. Mosaic tiles
                      in shades of grey and white can be quite chic. You could
                      also use textured tiles to create an accent wall.{" "}
                    </p>
                  </li>
                  <li>
                    {" "}
                    <h5>
                      <strong>
                        Enhance with Bathroom Mirrors and Accessories:
                      </strong>
                    </h5>
                    <p>
                      From round to rectangular shapes to frameless ones,
                      installing a bathroom mirror can help open up the space
                      and add a touch of elegance. Complement the mirror area
                      with proper lighting and keep functional accessories on
                      the countertop below the mirror. Also, floating shelves or
                      a ladder rack can help bring together storage and style.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Bring in Greenery: </strong>
                    </h5>
                    <p>
                      Add some greenery to your grey bathroom design and elevate
                      the entire atmosphere. Tiny potted plants on countertops
                      or hanging planters near windows work well.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Follow Trends or Go Classic: </strong>
                    </h5>
                    <p>
                      Trending{" "}
                      <a href="https://www.orientbell.com/design-ideas/bathroom-designs/">
                        bathroom designs{" "}
                      </a>
                      combine interesting tile patterns, coupled with stylish
                      fixtures. However, the classic decors are more towards a
                      timeless appeal. Do you want to go for a minimalist trend
                      for your next bathroom renovation? Or, do you want to
                      create a classic design? Figure this out and you can
                      always find tile designs that suit your desired bathroom
                      look.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className='designpage-faq-section padding-spacing'>
              <h2>FAQs About Grey Bathroom Design</h2>
              <div className="newacd designpage-faq-row">
                <ul className="accordion">
                  {displayedFAQs.map((faq, index) => (
                    <li key={index}>
                      <a className="toggle" onClick={() => handleToggle(index)}>
                        {index + 1}. {faq.question}
                      </a>
                      {activeIndex === index && (
                        <ul className="inner">
                          <li>{faq.answer}</li>
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                {faqs.length > 5 && (
          <div className='tru_btn_new design-page'>
          <button
            className='btn btn-primary'
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'Read More'}
          </button>
          </div>
        )}
              </div>
            </div> */}

            {relatedBlogData?.length > 0 && (
              <div className="tile-related-blog">
                <h2 className="title">Related Blogs</h2>
                <div className="designpage-relatedpost-row">
                  <Slider {...settings}>
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="related-blog-col" key={index}>
                          <div className="blog-figure">
                            <a href={obj.permalink}>
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                              />
                            </a>
                          </div>
                          <div className="blog-text">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                            <div className="listingText">
                              <p>
                                {" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.content.slice(0, -11),
                                  }}
                                />
                              </p>
                              <div className="listingButton">
                                <a href={obj.permalink}>Read More</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default GreyBathroom;
